<template>
  <div :style="WidgetUtils.renderStyle(widget.properties)">
    <textwidget v-if="widget.type == WidgetUtils.WidgetTypes.TEXT" :content="widget.properties.text" :color="widget.properties.color" :font="widget.properties.font" :letterspacing="widget.properties.letterSpacing" :lineheight="widget.properties.lineHeight" :size="widget.properties.size" :align="widget.properties.alignment" :link="widget.properties.link" :post="widget.properties.post" :download="widget.properties.download" :modal="widget.properties.modal" :role="widget.properties.role"></textwidget>
    <imagewidget v-if="widget.type == WidgetUtils.WidgetTypes.IMAGE"  :content="widget.properties.src + '?version=' + version" :link="widget.properties.link" :post="widget.properties.post" :download="widget.properties.download" :modal="widget.properties.modal" :alt="widget.properties.alt"></imagewidget>
    <iframewidget v-if="widget.type == WidgetUtils.WidgetTypes.IFRAME"  :content="widget.properties.url"></iframewidget>
    <!-- <guagewidget v-if="widget.type == WidgetUtils.WidgetTypes.GUAGE" :chartdata="widget.chartdata" :colors="widget.colors" :textcolor="widget.properties.color" :title="widget.properties.text" sig="guage1"></guagewidget>
    <piewidget v-if="widget.type == WidgetUtils.WidgetTypes.PIE" :chartdata="widget.chartdata" :colors="widget.colors" :textcolor="widget.properties.color" :title="widget.properties.text" :hovertitle="widget.properties.text" sig="pie1" :legend="widget.properties.legend"></piewidget>
    <p5ticker v-if="widget.type == WidgetUtils.WidgetTypes.TICKER" :color="widget.properties.color" :val="widget.properties.val"></p5ticker> -->
    <blockwidget v-if="widget.type == WidgetUtils.WidgetTypes.BLOCK" :color="widget.properties.color"></blockwidget>
    <jsappwidge v-if="widget.type == WidgetUtils.WidgetTypes.JS_APP" :script="widget.properties.script" :extras="widget.properties.extras"></jsappwidge>
    <!-- <svgticker v-if="widget.type == WidgetUtils.WidgetTypes.TICKER" :color="widget.properties.color" :val="widget.properties.val" :width="widget.properties.width"></svgticker> -->
  </div>
</template>
<script>
import WidgetUtils from './utils/WidgetUtils.js'
import GeneralUtils from './utils/GeneralUtils.js'
import TextWidget from './widgets/TextWidget.vue'
import ImageWidget from './widgets/ImageWidget.vue'
import IFrameWidget from './widgets/IFrameWidget.vue'
// import GuageWidget from './widgets/GuageWidget.vue'
// import PieWidget from './widgets/PieWidget.vue'
// import P5Ticker from './widgets/P5Ticker.vue'
import BlockWidget from './widgets/BlockWidget.vue'
// import SVGTicker from './widgets/SVGTicker.vue'
import JSAppWidget from './widgets/JSAppWidget.vue'
export default {
  components: {
    textwidget: TextWidget,
    imagewidget: ImageWidget,
    // guagewidget: GuageWidget,
    // piewidget: PieWidget,
    // p5ticker: P5Ticker,
    blockwidget: BlockWidget,
    // svgticker: SVGTicker,
    iframewidget: IFrameWidget,
    jsappwidge: JSAppWidget
  },
  props: ['widget', 'section', 'index', 'zone'],
  data () {
    return {
      WidgetUtils: WidgetUtils,
      version: GeneralUtils.getAppVersion()
    }
  },
  watch: {
    zone: function () {
      var self = this
      if (this.zone > -1) {
        WidgetUtils.initialise(self.widget.properties, self.widget.transition, this.zone)
      }
    }
  },
  mounted: function () {
    var self = this
    WidgetUtils.initialise(self.widget.properties, self.widget.transition, this.zone)
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/WidgetShell.vue